import React, { useMemo } from "react";
import { UncontrolledTooltip } from "reactstrap";
import classes from "./partlist.module.scss";
import { API_HOST } from "src/utils/constants";
import { useDraggable } from "@dnd-kit/core";
import { useAtom } from "jotai";
import { isAnyPartDraggingAtom } from "./EditThemeParts";
import { PartProps } from "./PartSmall";
import { v4 as uuidv4 } from "uuid";

export interface PartPropsDragging extends PartProps {
    notDraggable: boolean
};

export const PartSmallDragging: React.FC<PartPropsDragging> = ({ part, dragged, notDraggable, onContextMenu }) => {


    /**
     * if not draggable, set useDraggable(... ) with a random Id, 
     * so not to be mixed with the part in the theme with the same Id.
     * 
     */

    const draggableId = useMemo(() =>
        notDraggable ? uuidv4() : part.Id,
        [notDraggable, part.Id]
    );

    const domId = `l_${draggableId}`;

    const { isDragging, setNodeRef, listeners, attributes } = useDraggable({ id: draggableId });

    /**
     *  if this is true - there's a drag doing on somewhere. Just switch of all Tooltips.
     */
    const [isDraggingGlobal] = useAtom(isAnyPartDraggingAtom);

    const style = {
        opacity: isDragging ? "75%" : ""
    };


    const theCard = (<>
        <div className={`card-box card ${classes['part-listing-card']}`} >

            <div className={"text-center " + classes['card-image']}>
                {part.ImageUrl ?
                    <img draggable={false} src={API_HOST + part.ImageUrl} alt={part.Name} />
                    : <div className={classes.imageDummy + " w-100 h-100"}>&nbsp;</div>
                }

            </div>
            <div className=" overflow-hidden p-2">
                {part.Name}
            </div>
        </div>



        {!isDraggingGlobal &&
            <UncontrolledTooltip placement="auto-start" autohide={false} target={domId} trigger={'hover'}
                delay={{ show: 300 + (isDragging ? 100000 : 0), hide: 0 }}>
                <strong>{part.Name}</strong>
            </UncontrolledTooltip>
        }
    </>);

    if (notDraggable) {
        return (
            <div onContextMenu={onContextMenu} id={domId} className={`m-3 ${classes.partListing} ${classes.smallPart} ${classes.notDraggable} `} >
                {theCard}
            </div>
        );
    }
    else {
        return (

            <div onContextMenu={onContextMenu} style={style} ref={setNodeRef} id={domId}
                className={`m-3 ${classes.partListing} ${classes.smallPart} 
                    ${dragged && classes.dragged} ${notDraggable ? "" : "hand"}`}
                {...listeners} {...attributes}
            >

                {theCard}

            </div>

        );
    }

};